$( document ).ready(function() {
  $('.addCard_btn').on('click', function(event) {
  event.preventDefault();

  var $quickAddButton = $(this).parent().find('quick-add-component .quick-add__button--choose');
  console.log($quickAddButton);
  if ($quickAddButton.length) {
    $quickAddButton.trigger('click');
  }
});
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.popup_group .button').forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      // console.log('Default action prevented for .popup_group .button');
    });
  });
});


